import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/button-has-type */
const ButtonWithLoading = ({
  isBusy, className, type, children, ...rest
}) => (
  <button
    {...rest}
    type={type}
    disabled={isBusy}
    className={`${className}${isBusy ? ' loading' : ''}`}
  >
    {!isBusy && children}
  </button>
);
ButtonWithLoading.defaultProps = {
  className: '',
};

ButtonWithLoading.propTypes = {
  className: PropTypes.string,
  isBusy: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ButtonWithLoading;
